import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3c979b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputs" }

import {computed, ref} from "vue";
import {useDate} from "vuetify";
import i18n from "@/plugins/i18n";
import {EmbedTimestamp} from "@/types/Embed";
import {TemplateVariable} from "@/types/TemplateVariable";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimestampInput',
  props: /*#__PURE__*/_mergeModels({
    variables: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props
const date = useDate()
let timestamp = _useModel<EmbedTimestamp>(__props, "modelValue")
let datePicker = ref(false)
let formatted = computed(() => date.format(timestamp.value?.date, 'fullDateWithWeekday'))

if (timestamp.value?.type != "custom") timestamp.value.date = new Date()

const items = [
  {
    title: i18n.global.t('TimestampInput.items.current'),
    value: "current"
  },
  {
    title: i18n.global.t('TimestampInput.items.custom'),
    value: "custom"
  },
  {
    title: i18n.global.t('TimestampInput.items.template'),
    value: "template"
  }
]
const variables = []
if (props.variables.includes('member')) variables.push(
  {
    title: "{{member.created}}",
    props: {subtitle: i18n.global.t('TimestampInput.variables.memberCreated')},
    value: "{{member.created}}"
  },
  {
    title: "{{member.joined}}",
    props: {subtitle: i18n.global.t('TimestampInput.variables.memberJoined')},
    value: "{{member.joined}}"
  },
)
if (props.variables.includes('guild')) variables.push(
  {
    title: "{{guild.created}}",
    props: {subtitle: i18n.global.t('TimestampInput.variables.guildCreated')},
    value: "{{guild.created}}"
  }
)
if (props.variables.includes('punishment')) variables.push(
  {
    title: "{{punishment.ends}}",
    props: {subtitle: i18n.global.t('TimestampInput.variables.punishmentEnds')},
    value: "{{punishment.ends}}"
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_select, {
        modelValue: _unref(timestamp).type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(timestamp).type) = $event)),
        class: "input",
        color: "primary",
        "prepend-icon": "schedule",
        items: items,
        clearable: "",
        label: _ctx.$t('TimestampInput.label')
      }, null, 8, ["modelValue", "label"]),
      (_unref(timestamp).type === 'template')
        ? (_openBlock(), _createBlock(_component_v_select, {
            key: 0,
            modelValue: _unref(timestamp).template,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(timestamp).template) = $event)),
            class: "input",
            color: "primary",
            "prepend-icon": "data_object",
            items: variables,
            label: _ctx.$t('TimestampInput.variable')
          }, null, 8, ["modelValue", "label"]))
        : _createCommentVNode("", true),
      (_unref(timestamp).type === 'custom')
        ? (_openBlock(), _createBlock(_component_v_text_field, {
            key: 1,
            modelValue: _unref(formatted),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(formatted) ? (formatted).value = $event : formatted = $event)),
            class: "input",
            color: "primary",
            readonly: "",
            "prepend-icon": "calendar_month",
            label: _ctx.$t('TimestampInput.date')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_overlay, {
                modelValue: _unref(datePicker),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(datePicker) ? (datePicker).value = $event : datePicker = $event)),
                activator: "parent",
                scrim: false,
                "location-strategy": "connected",
                "scroll-strategy": "reposition"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_date_picker, {
                    modelValue: _unref(timestamp).date,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_unref(timestamp).date) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_isRef(datePicker) //@ts-ignore
 ? datePicker.value = false : datePicker = false))
                    ]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "label"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})